/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetChatMessagesRequest} from '@cash-web/protos/squareup/cash/supportal/app.pb'
import {GetChatMessagesResponse} from '@cash-web/protos/squareup/cash/supportal/app.pb'


export const getChatMessages = (request:GetChatMessagesRequest, options?: CashRequestOptions) => post<GetChatMessagesRequest, GetChatMessagesResponse>("/2.0/cash/get-chat-messages", request, {...options, rejectOnError: true })